import React from "react";
import { cn } from "src/utils/cn";
import { ClozdlMark } from "src/components/ClozdlMark";

const SIZES = {
    default: { mark: 34, text: "text-xl", tile: "h-9 w-9 rounded-[10px]" },
    lg: { mark: 52, text: "text-3xl", tile: "h-14 w-14 rounded-2xl" },
};

// Clozdl wordmark lockup: the calligraphic "C" mark + "Clozdl.ai".
//
// variant "white"  -> for dark/navy surfaces (marketing, auth brand panel):
//                     bare gold C, white text, gold ".ai".
// variant "default" -> for light surfaces (dashboard, invitations):
//                     gold C inside a navy tile, dark text, gold ".ai".
export function Logo({ className = "", variant = "default", size = "default" }) {
    const isWhite = variant === "white";
    const { mark: markSize, text: textClass, tile } = SIZES[size] || SIZES.default;

    return (
        <div className={cn("flex items-center gap-2.5", className)}>
            {isWhite ? (
                <ClozdlMark size={markSize} color="#C9B482" />
            ) : (
                <span className={cn("flex shrink-0 items-center justify-center bg-[#05081D]", tile)}>
                    <ClozdlMark size={Math.round(markSize * 0.72)} color="#C9B482" />
                </span>
            )}
            <span className={cn("font-bold tracking-tight", textClass, isWhite ? "text-white" : "text-slate-900")}>
                Clozdl<span className="text-[#C9B482]">.ai</span>
            </span>
        </div>
    );
}
